<template>
    <div class="head-container">
        <el-row type="flex" align="middle" style="width: 100%">
            <el-col :span="4" style="text-align: center">
                <div class="wel-logo cursor"
                     @click="jumpPageNotAuth('/hyedu/wel')">
                    <img class="cursor" style="width: 60px;height: 60px;" src="../assets/hy_logo.png" alt="">
                    恒岳教研
                </div>
            </el-col>
            <el-col :span="isLogin?15:16" >
                <el-menu mode="horizontal"
                         :ellipsis="false"
                         background-color="transparent"
                         active-background-color="#0d55a4"
                         :default-active="activePath"
                         text-color="#ffffff"
                         active-text-color="#ffbf6b"
                         @select="handleMenuChange">
                    <el-menu-item index="welHome" >
                        <div @click="jumpPageNotAuth('/hyedu/wel')">
                            首页
                        </div>
                    </el-menu-item>
                    <el-menu-item index="homeResourceCentre" @click="jumpPageHome('/hyedu/resource','homeResourceCentre','1')" >
                        <div>资源中心</div>
                    </el-menu-item>
                    <el-menu-item index="homeEduResearch" @click="jumpPageHome('/hyedu/research','homeEduResearch','2')" >
                        <div>一体化教研</div>
                    </el-menu-item>
                    <el-menu-item index="homeTeachResearch"  @click="jumpPageHome('/hyedu/tearesearch','homeTeachResearch','1')">
                        <div>教科研</div>
                    </el-menu-item>
                    <el-menu-item index="teacherTrainCenter" @click="jumpPageHome('/hyedu/train','rectorStudioHome','1')">
                        <div>师资培训</div>
                    </el-menu-item>
                    <el-menu-item index="rectorStudioHome" @click="jumpPageHome('/hyedu/rectorstudio','rectorStudioHome','1')">
                        <div>
                            名校长工作室
                        </div>
                    </el-menu-item>
                    <el-menu-item index="teachStudioHome" @click="jumpPageHome('/hyedu/teastudio','teachStudioHome','1')">
                        <div>名师工作室</div>
                    </el-menu-item>
                    <el-menu-item index="teachToolLink">
                        <el-popover placement="bottom" trigger="hover" :width="100"
                                    :show-arrow="true"
                                    :popper-style="{padding: '0',background:'#0d55a4',border: 'none',minWidth:'110px'}">
                            <div class="menu-item-list">
                                <div class="menu-item" @click="teachingToolLink('1')">课堂评价</div>
                                <div class="menu-item" @click="teachingToolLink('2')">心理评价</div>
<!--                                <div class="menu-item" @click="teachingToolLink('3')">生涯规划</div>-->
                            </div>
                            <template #reference>
                                <div>评估评价</div>
                            </template>
                        </el-popover>
                    </el-menu-item>

                    <el-menu-item index="homeManagerCenter" @click="jumpPageHome('/hyedu/managercenter','homeManagerCenter','1')">
                        <div>我的管理</div>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <!--未登录-->
            <el-col :span="4" v-if="!isLogin">
                <div class="login-res-box">
                    <button class="btn" @click="userToLogin">登录</button>
                    <button class="btn" style="right: -20px" @click="userToReg">注册</button>
                </div>
            </el-col>
            <!--已登录-->
            <el-col :span="5" v-if="isLogin">
                <el-row justify="start" type="flex" align="middle">
                    <el-col :span="1">
                    </el-col>
                    <el-col :span="8">
                        <button v-has-btn="'1,2,3,'" class="btn" @click="userAdmin">管理中心</button>
                    </el-col>
                    <el-col :span="12" >
                        <div class="tr-img">
                            <el-badge :is-dot="messageBol" style="margin-top: 4px">
                                <img class="cursor" src="../assets/homePage/rw.png"
                                     @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','3')"
                                     alt="任务中心">
                            </el-badge>
                            <el-badge :is-dot="systemBol" class="item">
                                <img class="cursor" src="../assets/homePage/xx.png"
                                     @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','2')"
                                     alt="消息中心">
                            </el-badge>

                            <el-dropdown class="cursor">
                                <el-avatar style="margin-left: 15px;" :size="30" :src="userInfo.avatar + '?_=' + Date.now()" />
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item style="text-align: center;" @click="jumpPageHome('/hyedu/usercenter','homeUserCenter','1')">个人中心</el-dropdown-item>
                                        <el-dropdown-item style="text-align: center;" @click="userLogout">安全退出</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>


<script>
import {timestampToTime} from "@/utils/date";
import {userMessages} from "@/api/admin/message";
export default {
    name: "homeHead",
    props: {
    },
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            messageBol: false,
            systemBol: false,
            activePath: "welHome",
            lastActivePath: "",
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            classroomUrl:'http://aipowered.k12.seegot.cn/#/login',//课堂分析
            psychicUrl:'https://xlfw.net/',//心理咨询
            careerUrl:'',//生涯规划


        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.isLogin){
            this.getMessage()
        }
        var currentDate = new Date();
        var currentHour = currentDate.getHours();
        if (0 <= currentHour && currentHour <= 6) {
            this.timeInfo = '凌晨'
        } else if (6 < currentHour && currentHour <= 12) {
            this.timeInfo = '上午'
        } else if (12 < currentHour && currentHour <= 18) {
            this.timeInfo = '下午'
        } else {
            this.timeInfo = '晚上'
        }
    },
    mounted() {},
    methods: {
        handleMenuChange(key, path){
            this.lastActivePath = this.activePath
            this.activePath = path;
        },
        userToLogin(){
            this.$router.push("/login")
        },
        userToReg(){
            this.$router.push("/register")
        },
        userLogout() {
            this.$confirm("您正在退出恒岳教研，是否继续？", "退出系统", {
                confirmButtonText: "退出",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$storage.remove("token")
                this.$storage.remove("userInfo")
                this.$storage.remove("role");
                this.$storage.remove("isLogin");
                this.isLogin=false
                this.$router.push({ path: "/hyedu/wel" });
            })
        },
        jumpPage(activePath, activeSecondPath){
            if (this.isLogin){
                window.sessionStorage.setItem('activePath', activePath)
                window.sessionStorage.setItem('activeSecondPath', activeSecondPath)
                this.$router.push({ path: '/home' });
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        jumpPageNotAuth(path){
            this.$router.push(path);
        },
        jumpPageHome(path,activePath,activeItem){
            if (this.isLogin){
                //参数传递
                this.$store.commit("params/setJumpParams", {activePath:activePath,activeItem: activeItem});
                this.$router.push({path: path,});
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        userAdmin(){
            this.$router.push({ path: '/hyedu/home' });
        },
        getMessage() {
            userMessages({ code: 1 }).then(res => {
                this.systemBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        this.systemBol = true;
                    }
                })
            });
            userMessages().then(res => {
                this.messageBol = false;
                res.data.data.forEach(e => {
                    if (e.isRead === 0) {
                        if (e.code !== 1) {
                            this.messageBol = true;
                        }
                    }
                })
            });
        },
        teachingToolLink(type){
            if (this.isLogin){
                let toolLink = this.classroomUrl;
                if (type==='2'){
                    toolLink = this.psychicUrl
                }
                if (type==='3'){
                    toolLink = this.careerUrl
                }
                window.open(toolLink, '_blank')
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        }
    }

};
</script>

<style scoped lang="scss">
.head-container{
    height: 70px;
    width: 100%;
    background: #0d55a4;
    position: fixed;
    top: 0;
    z-index: 999;
}
/deep/ .el-menu {
    height: 70px;
    border-bottom: none!important;
    width: auto;
}
/deep/ .el-menu-item {
    font-size: 16px;
    height: 70px;
    padding: 10px 10px;
}
/deep/ .el-menu-item.is-active{
    font-weight: bold;
    font-size: 16px;
    border-bottom: none!important;
    background-color: #0d55a4;
    div{
        height: 30px;
        line-height: 30px;
        border-bottom: 2px solid #ffbf6b !important;
    }
}
.menu-box{
    height: 30px;
    line-height: 30px;

}
.login-res-box{
    display: flex;
    height: 30px;
    margin-top: 5px;
    margin-left: 30px;
}
.btn{
    position: relative;
    width: auto;
    padding: 0 10px 0 10px;
    height: 26px;
    text-align: center;
    color: #0d55a4;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
    border: none;
}
.btn:hover{
    color: #fff;
    background: #0d55a4;
    border: 1px solid #ffffff;
}
.tr-img {
    display: flex;
    align-items: center;
    justify-content: start;
    padding-right: 40px;
    box-sizing: border-box;
    img {
        width: 20px;
        height: 24px;
        margin-left: 15px;
    }
}
.wel-logo{
    display: flex;
    align-items: center;
    color: #e7eef6;
    font-size: 20px;
    img {
        width: 60px;
        margin-left: 30px;
        margin-right: 10px;
    }
}
::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    opacity: 0.9 !important;
    background: #0d55a4;
}
::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 0;
    background: #c1c6cd;
}
.menu-item-list{
    //width: 120px;
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
}
.menu-item{
    background: #0d55a4;
    color: #fff;
    width: auto;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    cursor: pointer;
    text-align: center;
}
.menu-item:hover{
    color: #ffbf6b;
    font-weight: bold;
}
</style>